<div class="cambio-password mt-5" style="width: 30%;margin: 0 auto;">

    <h4 style="text-align: center;">Cambio de contraseña</h4>


    <div class="form card-body" style="margin: 0 auto;text-align: center;">


      <form (ngSubmit)="cambiarPassword(f,cambio.usuario,cambio.password,cambio.confirmar);" #f="ngForm" class="form-horizontal form-material login-form m-t-20">
        
        <small *ngIf="usuario.invalid && usuario.touched" class="form-text text-danger animated fadeIn">Escriba su nombre de usuario</small>
        <div class="form-group m-t-5">
            <div class="col-xs-12">
                <input [(ngModel)]="cambio.usuario" class="form-control" type="text" name="usuario" required  #usuario="ngModel" readonly/>
            </div>
        </div>


        <small *ngIf="password.invalid && password.touched" class="form-text text-danger animated fadeIn">Olvido escribir su contraseña</small>  
        <div class="form-group m-t-5">
            <div class="col-xs-12">
        <input [(ngModel)]="cambio.password" class="form-control" type="password" name="password" required placeholder="Nueva contraseña" #password="ngModel"/>
        </div>
        </div>


        <small *ngIf="confirmar.invalid && confirmar.touched" class="form-text text-danger animated fadeIn">Olvido confirmar su contraseña</small>  
        <div class="form-group m-t-5">
            <div class="col-xs-12">
        <input [(ngModel)]="cambio.confirmar" class="form-control" type="password" name="confirmar" required placeholder="Confirmar contraseña" #confirmar="ngModel"/>
        </div>
        </div>

        <button class="btn btn-success" type="submit">Confirmar cambio</button>

        <br>

      </form>
        </div>


</div>